import React from 'react';
import { HiTemplate } from 'react-icons/hi';
import { useSettings } from '../../context/SettingsContext';

const PresetSelector = () => {
  const { applyPreset } = useSettings();

  const presets = [
    {
      name: 'conservative',
      label: '보수적',
      description: '낮은 리스크, 안정적인 수익 추구',
      color: 'blue',
    },
    {
      name: 'balanced',
      label: '균형적',
      description: '중간 리스크, 균형잡힌 수익 추구',
      color: 'green',
    },
    {
      name: 'aggressive',
      label: '공격적',
      description: '높은 리스크, 높은 수익 추구',
      color: 'red',
    },
  ];

  const handlePresetClick = (presetName) => {
    if (window.confirm(`"${presets.find(p => p.name === presetName).label}" 프리셋을 적용하시겠습니까?\n현재 설정이 변경됩니다.`)) {
      applyPreset(presetName);
    }
  };

  return (
    <div className="bg-gray-800 rounded-lg p-4 sm:p-6">
      <div className="flex items-center space-x-2 mb-4">
        <HiTemplate className="text-xl sm:text-2xl text-blue-500" />
        <h3 className="text-lg sm:text-xl font-bold text-white">설정 프리셋</h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
        {presets.map((preset) => (
          <button
            key={preset.name}
            onClick={() => handlePresetClick(preset.name)}
            className={`
              p-4 rounded-lg border-2 transition-all
              ${preset.color === 'blue' ? 'border-blue-500 hover:bg-blue-500/10' : ''}
              ${preset.color === 'green' ? 'border-green-500 hover:bg-green-500/10' : ''}
              ${preset.color === 'red' ? 'border-red-500 hover:bg-red-500/10' : ''}
              text-left
            `}
          >
            <div className={`
              text-base sm:text-lg font-bold mb-2
              ${preset.color === 'blue' ? 'text-blue-500' : ''}
              ${preset.color === 'green' ? 'text-green-500' : ''}
              ${preset.color === 'red' ? 'text-red-500' : ''}
            `}>
              {preset.label}
            </div>
            <div className="text-xs sm:text-sm text-gray-400">
              {preset.description}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default PresetSelector;
